//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import { GaApi } from 'app/initialization/ga/ga-api';

class WelcomeScreenResourceLink {
  public target: string;

  constructor(
    private trackingService: GaApi,
  ) {}

  public onClick() {
    this.trackingService.recordEvent(
      this.trackingService.CATEGORY_WELCOME_SCREEN,
      this.trackingService.ACTION_NAVIGATION3_WELCOME_SCREEN_RESOURCES_CLICK,
      this.target,
    );
  }
}

angular.module('curalate').component('welcomeScreenResourceLink', {
  template: `
        <p class="cu-d-flex">
            <cu-icon name="linkout" class="cu-mt-1 cu-mr-2"></cu-icon>
            <a
                ng-href="{{ $ctrl.target }}"
                target="_blank"
                class="cu-text-body-secondary"
                ng-transclude
                ng-click="$ctrl.onClick()"
            ></a>
        </p>`,
  transclude: true,
  bindings: {
    target: '@',
  },
  controller: [
    'TrackingService',
    WelcomeScreenResourceLink,
  ],
});
